import React from "react"
import { Box, Button } from "@material-ui/core"

import { ReservationFormBody } from "./ReservationFormBody"
import { ReservationFormWrapper } from "./ReservationFormWrapper";
import {makeMessages} from "../../utils/makeMessages";



export interface ReservationFormProps {
	variant: 'filled' | 'outlined',
}


export const ReservationForm = (props: ReservationFormProps) => {
	const { variant } = props;

	const msgs = useMessages();
	return (
		<div>
			<ReservationFormWrapper>
				<ReservationFormBody
					variant={variant}
				/>
				<Box marginTop={1}>
					<Button type="submit" variant="contained" color="primary">{msgs.submit}</Button>
				</Box>
			</ReservationFormWrapper>
		</div>
	);
}

const useMessages = makeMessages({
	submit: {
		sk: 'Odoslať',
		en: 'Submit',
	},
});
